import React from 'react';
import PropTypes from 'prop-types';
import {graphql, compose} from 'react-apollo';
import moment from 'moment';
import TimeQuery from 'gql/time.gql';

let offset = 0;

moment.now = () => {
    return offset + (+new Date());
};

export const setCurrentTime = (time) => {
    offset = parseInt(time, 10) * 1000 - (+new Date());
};

export const TimeProvider = compose(
    graphql(TimeQuery, {
        name: 'timeQuery',
        options: {
            fetchPolicy: 'network-only',
        }
    })
)(
    class extends React.Component {
        static propTypes =  {
            timeQuery: PropTypes.object.isRequired,
            children: PropTypes.node.isRequired,
        };

        componentWillReceiveProps(props) {
            if (!props.timeQuery.loading) {
                setCurrentTime(props.timeQuery.serverTime);
            }
        }

        render() {
            if (this.props.timeQuery.loading) {
                return null;
            }

            return this.props.children;
        }
    }
);


// WEBPACK FOOTER //
// ./src/helpers/time.js